import { render, staticRenderFns } from "./SoumissionRliss.vue?vue&type=template&id=56799832&"
import script from "./SoumissionRliss.vue?vue&type=script&lang=js&"
export * from "./SoumissionRliss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports